import { render, staticRenderFns } from "./CardBorderWidget.vue?vue&type=template&id=1aebcfce&scoped=true"
import script from "./CardBorderWidget.vue?vue&type=script&lang=js"
export * from "./CardBorderWidget.vue?vue&type=script&lang=js"
import style0 from "./CardBorderWidget.vue?vue&type=style&index=0&id=1aebcfce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aebcfce",
  null
  
)

export default component.exports